import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../../data/mock';

const LegalPage = () => {
  return (
    <div className="py-12 md:py-16">
      <div className="max-w-4xl mx-auto px-4">
        {/* Breadcrumb */}
        <nav className="mb-8 text-sm">
          <ol className="flex items-center gap-2 text-[#94A3B8]">
            <li><Link to="/" className="hover:text-[#1E6BB8]">Accueil</Link></li>
            <li>/</li>
            <li className="text-[#1F2937] font-medium">Mentions légales</li>
          </ol>
        </nav>

        <h1 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-8">Mentions légales</h1>

        <div className="prose prose-gray max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-bold text-[#1F2937] mb-4">Éditeur du site</h2>
            <p className="text-[#94A3B8]">
              <strong className="text-[#1F2937]">EMS Express Miroiterie Serrurerie</strong><br />
              {companyInfo.fullAddress}<br />
              Téléphone : {companyInfo.phone}<br />
              Email : {companyInfo.email}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#262626] mb-4">Hébergement</h2>
            <p className="text-[#666666]">
              Ce site a été conçu et développé par <a href="https://www.info-glotech.fr" target="_blank" rel="noopener noreferrer" className="text-[#B91C1C] hover:underline">Glotech</a>.<br />
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1F2937] mb-4">Propriété intellectuelle</h2>
            <p className="text-[#94A3B8]">
              L'ensemble du contenu de ce site (textes, images, vidéos, etc.) est protégé 
              par le droit d'auteur. Toute reproduction, même partielle, est interdite sans 
              autorisation préalable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1F2937] mb-4">Données personnelles</h2>
            <p className="text-[#94A3B8]">
              Les informations collectées via le formulaire de contact sont destinées 
              exclusivement à EMS Express pour le traitement de votre demande. Conformément 
              à la loi "Informatique et Libertés" et au RGPD, vous disposez d'un droit 
              d'accès, de rectification et de suppression de vos données.
            </p>
            <p className="text-[#94A3B8] mt-2">
              Pour exercer ce droit, contactez-nous à : {companyInfo.email}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1F2937] mb-4">Cookies</h2>
            <p className="text-[#94A3B8]">
              Ce site peut utiliser des cookies à des fins de mesure d'audience et 
              d'amélioration de l'expérience utilisateur. Vous pouvez à tout moment 
              désactiver les cookies dans les paramètres de votre navigateur.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1F2937] mb-4">Responsabilité</h2>
            <p className="text-[#94A3B8]">
              EMS Express s'efforce de fournir des informations exactes sur ce site. 
              Toutefois, nous ne pouvons garantir l'exactitude, la complétude ou 
              l'actualité de toutes les informations présentées.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;